import "./Form.scss";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";

const Form = (props) => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");

  const { isButtonSendClicked } = useSelector((state) => ({
    ...state.articlesReducer,
  }));

  const dispatch = useDispatch();

  const handleForm = (e) => {
    e.preventDefault();

    import("../../redux/actions").then((action) => {
      dispatch(action.setButtonSendClicked());
    });

    if (title === "" || body === "") {
      return;
    } else {
      const newArticle = {
        id: uuidv4(),
        title: title,
        body: body,
      };

      import("../../redux/actions").then((action) => {
        dispatch(action.addArticle(newArticle));
      });

      setTitle("");
      setBody("");
      e.target.reset();
    }
  };

  return (
    <>
      <h1 className="title-form">Écrivez un article</h1>

      <form id="form" className="container-form" onSubmit={handleForm}>
        <label className="label-title" htmlFor="title">Titre</label>
        <input
          type="text"
          id="title"
          className="input-title"
          placeholder="Entrez votre titre"
          onChange={(e) => setTitle(e.target.value)}
        />
        {!title && isButtonSendClicked && (
          <div className="invalid-input">Veuillez saisir un titre</div>
        )}

        <label className="label-body" htmlFor="article">Votre article</label>
        <textarea
          id="article"
          className="input-body"
          placeholder="Votre article"
          onChange={(e) => setBody(e.target.value)}
        ></textarea>
        {!body && isButtonSendClicked && (
          <div className="invalid-input">Veuillez saisir votre article</div>
        )}

        <button className="button-send">Envoyez l'article</button>
      </form>
    </>
  );
};

export default Form;
